module.exports = __webpack_public_path__ + "img/ewh-5.e8ba1b77.png";